import { ApolloClient, HttpLink, InMemoryCache } from '@apollo/client';
import fetch from 'isomorphic-fetch';
import possibleTypes from './possibleTypes';
import typePolicies from './typePolicies';

// TODO set this to the server path.
const graphqlUri =
  process.env.GATSBY_GRAPHQL_URI || 'https://api.bottlebooks.me/graphql';
console.log(graphqlUri);

const client = new ApolloClient({
  cache: new InMemoryCache({
    possibleTypes,
    typePolicies,
  }),
  link: new HttpLink({
    uri: graphqlUri,
    credentials: 'include',
    fetch,
  }),
});

export default client;
